/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
  * When the roles of the logged in use is passed here as the parameter it checks if it is a superadmin or  superviwer\
  * Based on the check it returns true and false
  * @param roles All the roles of the logged in user
**/

export function checkAdmin(roles) {
  let superAdmin, superViewer;
  superAdmin = roles?.find(pair => pair.role === 'admin' && !pair.instance);
  superViewer = roles?.find(pair => pair.role === 'viewer' && !pair.instance);
  return superAdmin || superViewer || false;
}
